import ClientFormsV1 from './v1';
import ClientFormsV2 from './v2';

// Default export - new modern version
export default ClientFormsV2;

// Named exports for specific versions
export { ClientFormsV1, ClientFormsV2 };